import GATSBY_COMPILED_MDX from "/opt/buildhome/repo/content/posts/self-aware-malware-outsmarting-sandboxes-human-like-behavior.mdx";
import React from "react";
import Layout from "./Layout";
import Seo from "./Seo";
import Hero from "./Hero";
import NewsletterSidebar from "./NewsletterSidebar";
import FeaturedCourse from "./FeaturedCourse";
function formatDate(iso) {
  if (!iso) return null;
  try {
    return new Intl.DateTimeFormat("en-GB", {
      day: "numeric",
      month: "long",
      year: "numeric",
      timeZone: "UTC"
    }).format(new Date(iso));
  } catch {
    return null;
  }
}
function PageTemplate({pageContext, children}) {
  const {frontmatter} = pageContext;
  const title = frontmatter?.title || "";
  const description = frontmatter?.description || "";
  const slug = frontmatter?.slug || "";
  const heroImage = frontmatter?.heroImage || null;
  const date = frontmatter?.date || null;
  const lastmod = frontmatter?.lastmod || null;
  const publishedLabel = formatDate(date);
  const updatedLabel = lastmod && lastmod !== date ? formatDate(lastmod) : null;
  return React.createElement(Layout, null, heroImage && React.createElement(Hero, {
    title: title,
    subtitle: description,
    backgroundImage: heroImage
  }), React.createElement("article", {
    className: "page-content"
  }, React.createElement("div", {
    className: "container"
  }, publishedLabel && React.createElement("p", {
    className: "post-meta"
  }, React.createElement("time", {
    dateTime: date
  }, "Published ", publishedLabel), updatedLabel && React.createElement(React.Fragment, null, " · ", React.createElement("time", {
    dateTime: lastmod
  }, "Updated ", updatedLabel))), React.createElement("div", {
    className: "post-layout-grid"
  }, React.createElement("div", {
    className: "post-main"
  }, children), React.createElement("aside", {
    className: "post-sidebar",
    "aria-label": "Sidebar"
  }, React.createElement("div", {
    className: "post-sidebar-scroll"
  }, React.createElement(FeaturedCourse), React.createElement(NewsletterSidebar, {
    sourceUrl: slug
  })))))));
}
export default function GatsbyMDXWrapper(props) {
  return React.createElement(PageTemplate, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
export function Head({pageContext}) {
  const {frontmatter} = pageContext;
  const siteUrl = "https://www.veil-framework.com";
  const heroImage = frontmatter?.heroImage ? `${siteUrl}${frontmatter.heroImage}` : null;
  return React.createElement(Seo, {
    title: frontmatter?.title,
    description: frontmatter?.description,
    pathname: frontmatter?.slug
  }, frontmatter?.date && React.createElement("meta", {
    property: "article:published_time",
    content: frontmatter.date
  }), frontmatter?.lastmod && React.createElement("meta", {
    property: "article:modified_time",
    content: frontmatter.lastmod
  }), heroImage && React.createElement("meta", {
    property: "og:image",
    content: heroImage
  }), heroImage && React.createElement("meta", {
    name: "twitter:image",
    content: heroImage
  }));
}
